import React, { useEffect, useState } from 'react';
import { Button, Input, Select, Space, Typography, Tag, Popconfirm, Divider } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { updateBot } from '../../reducers/bots/resources';

const { Text } = Typography;
const { Option } = Select;

export default function Globals({ bot, modules = [] }) {
    const [globals, setGlobals] = useState(bot?.globals || []);
    const [value, setValue] = useState('');
    const [goto, setGoto] = useState('');

    useEffect(() => {
        setGlobals(bot?.globals || []);
    }, [bot]);

    const persist = async (next) => {
        setGlobals(next);
        if (bot?.id) await updateBot(bot.id, { globals: next });
    };

    const handleCreate = async () => {
        if (!value.trim() || !goto) return;
        const next = [...globals, { value: value.trim(), goto }];
        await persist(next);
        setValue('');
        setGoto('');
    };

    const handleDelete = async (g) => {
        const next = globals.filter((x) => !(x.value === g.value && x.goto === g.goto));
        await persist(next);
    };

    const moduleName = (id) => modules.find((m) => m.id === id)?.title || 'Unknown';

    return (
        <div>
            {globals.length === 0 && (
                <Text type="secondary" style={{ display: 'block', fontSize: 12, margin: '4px 0' }}>
                    No global keywords yet
                </Text>
            )}
            {globals.map((g, i) => (
                <div key={`${g.value}-${g.goto}-${i}`} className="connection-row">
                    <Tag color="green" style={{ fontSize: 11 }}>{g.value}</Tag>
                    <Text style={{ fontSize: 12 }}>→ {moduleName(g.goto)}</Text>
                    <Popconfirm
                        title="Delete this global?"
                        onConfirm={() => handleDelete(g)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="text" danger size="small" icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ))}
            <Divider style={{ margin: '8px 0' }} />
            <Space.Compact style={{ width: '100%' }}>
                <Input
                    placeholder="Keyword"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    style={{ flex: 1 }}
                />
                <Select
                    placeholder="Go to…"
                    value={goto || undefined}
                    onChange={setGoto}
                    style={{ width: 160 }}
                >
                    {modules.map((m) => (
                        <Option key={m.id} value={m.id}>{m.title}</Option>
                    ))}
                </Select>
                <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
                    Add
                </Button>
            </Space.Compact>
        </div>
    );
}
